
































import Vue from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import ClipButton from "@/components/Molecules/ClipButton/index.vue";
import GraduateYearBadge from "@/components/Atoms/GraduateYearBadge/index.vue";
import CompanyHeading from "@/components/Molecules/CompanyHeading/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { PropType } from "vue/types/umd";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventHeader",
  components: {
    Heading,
    ClipButton,
    GraduateYearBadge,
    CompanyHeading
  },
  props: {
    company: {
      type: Object as PropType<Props["company"]>,
      default: undefined
    },
    title: {
      type: String as PropType<Props["title"]>,
      default: ""
    },
    graduateYear: {
      type: Number as PropType<Props["graduateYear"]>,
      required: true,
      default: 0
    },
    clipId: {
      type: Number as PropType<Props["clipId"]>,
      default: 0
    },
    clipCount: {
      type: Number as PropType<Props["clipCount"]>,
      default: 0
    },
    period: {
      type: String as PropType<Props["period"]>,
      default: ""
    },
    size: {
      type: String as PropType<Props["size"]>,
      default: "medium",
      validator(val) {
        return ["large", "medium", "small"].includes(val);
      }
    },
    showClip: {
      type: Boolean as PropType<Props["showClip"]>,
      default: false
    },
    showRating: {
      type: Boolean as PropType<Props["showRating"]>,
      default: false
    },
    shortGraduateYear: {
      type: Boolean as PropType<Props["shortGraduateYear"]>,
      default: false
    }
  },
  data() {
    return {
      clipped: false
    };
  },
  computed: {
    eventHeaderClasses() {
      return ["eventHeader", `eventHeader--size--${this.size}`];
    }
  },
  mounted() {
    this.clipped = Boolean(this.clipId);
  },
  methods: {
    toggleClipped(clipped) {
      this.clipped = clipped;
      this.$emit("toggleClipped", clipped);
    }
  }
});
